export const CreateConfig = (ParentFormKey) => {
  return [
    {
      id: Math.random() * 10,
      name: "Field_Details",
      fields: [
        {
          id: Math.random() * 10,
          name: "Serial_Number",
          label: "Serial Number",
          type: "Number",
          isRequired: true,
          autoFocus: true,
        },
        {
          id: Math.random() * 10,
          name: "Section_Id",
          label: "Section",
          type: "InputDropForQuery",
          masterName: "form_Sections",
          variable: {
            form_key: ParentFormKey,
          },
          FirstCharCap: true,
          isRequired: true,
        },
        {
          id: Math.random() * 10,
          name: "label",
          label: "Field Label",
          type: "text",
          FirstCharCap: true,
          isRequired: true,
        },
        {
          id: Math.random() * 10,
          name: "type",
          label: "Data Type",
          type: "inputdrop",
          dropdowndata: [
            "Text Box(Single Line)",
            "Email",
            "Mobile No",
            "Number",
            "Date",
            "Check-Box",
            "Dropdown",
            "Multi-Select",
            "Text Box(Multi Line)",
            "Attachment",
          ],
          min: 0,
          max: Infinity,
        },
        {
          id: Math.random() * 10,
          name: "placeholder",
          label: "Placeholder",
          type: "text",
          FirstCharCap: true,
        },
        // {
        //   id: Math.random() * 10,
        //   name: "isRequired",
        //   label: "Is Required",
        //   type: "Check-Box",
        // },
        // {
        //   id: Math.random() * 10,
        //   name: "disabled",
        //   label: "Is Disabled",
        //   type: "Check-Box",
        // },
      ],
    },
  ];
};
